export const appName = 'PromopushkaBot'
